import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ChevronLeft, ChevronRight, Save } from "lucide-react";
import '../../styles/omrsheet.css';
import { SafeToast } from "../Toast/ShowToast";
import Swal from 'sweetalert2';
import { IoArrowBack } from "react-icons/io5";
const OMRPage = () => {
  const navigate = useNavigate();
  const totalQuestions = parseInt(localStorage.getItem('totalQuestions')) || 0;
  const savedAnswers = JSON.parse(localStorage.getItem('omrAnswers') || '{}');

  console.log(totalQuestions, "totalQuestionstotalQuestions")

  const questionsPerPage = 40;
  const totalPages = Math.ceil(totalQuestions / questionsPerPage);

  const options = ["A", "B", "C", "D"];
  const [answers, setAnswers] = useState(savedAnswers);
  console.log(answers, 'answersanswers')
  const [currentPage, setCurrentPage] = useState(1);
  const [isChanged, setIsChanged] = useState(false);
  const location = useLocation();
  const Omrbatches = location.pathname === "/omr/batches";

  // Save answers to localStorage whenever they change
  useEffect(() => {
    localStorage.setItem('omrAnswers', JSON.stringify(answers));
  }, [answers]);

  const handleAnswer = (qNo, opt) => {
    setAnswers(prev => {
      const newAnswers = { ...prev, [qNo]: opt };
      // Check if answer changed
      const isAnswerChanged = prev[qNo] !== opt;
      if (isAnswerChanged) {
        setIsChanged(true);
      }
      return newAnswers;
    });
  };

  const startQuestion = (currentPage - 1) * questionsPerPage + 1;
  const endQuestion = Math.min(currentPage * questionsPerPage, totalQuestions);

  // Render 5 questions per column
  const renderColumn = (questions) => {
    return questions.map((qNo) => {
      if (qNo > totalQuestions) return null;
      return (
        <div key={qNo} className="omr-row-custom">
          <span className="q-number-label">{qNo}.</span>
          <div className="bubbles-group">
            {options.map((opt) => (
              <button
                key={opt}
                className={`bubble-item ${answers[qNo] === opt ? "filled" : ""}`}
                onClick={() => handleAnswer(qNo, opt)}
              >
                {opt}
              </button>
            ))}
          </div>
        </div>
      );
    });
  };

  const goToNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const goToPrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleSave = () => {
    // Save answers to localStorage
    const answeredCount = Object.keys(answers).length;
    const hasEmpty = Object.values(answers).some(val => !val);
    if (answeredCount !== totalQuestions || hasEmpty) {
      SafeToast.error("Please answer all questions before saving!");
      return;
    }

    localStorage.setItem('omrAnswers', JSON.stringify(answers));
    setIsChanged(false);
    // Show success message using SafeToast
    SafeToast.success("Answers saved successfully!");

    // Navigate back to UploadPage with questions tab active
    navigate('/', {
      state: {
        activeTab: 'questions'
      }
    });
  };

  const handleClearAll = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You want to clear all answers? This action cannot be undone!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, clear all!',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
      customClass: {
        confirmButton: 'swal-confirm-btn',
        cancelButton: 'swal-cancel-btn'
      }
    }).then((result) => {
      if (result.isConfirmed) {
        setAnswers({});
        setIsChanged(true);
        localStorage.setItem('omrAnswers', JSON.stringify({}));

        // Show success message
        Swal.fire({
          title: 'Cleared!',
          text: 'All answers have been cleared.',
          icon: 'success',
          timer: 1500,
          showConfirmButton: false
        });
      }
    });
  };

  // Split questions into 4 columns with 5 questions each per page
  const getQuestionsForColumns = () => {
    const questionsForCurrentPage = [];
    const questionsPerColumn = 10;
    const columns = 4;

    for (let i = startQuestion; i <= endQuestion; i++) {
      questionsForCurrentPage.push(i);
    }

    // Split into 4 columns with 5 questions each
    const columnData = [];
    for (let col = 0; col < columns; col++) {
      const startIdx = col * questionsPerColumn;
      const endIdx = startIdx + questionsPerColumn;
      columnData.push(questionsForCurrentPage.slice(startIdx, endIdx));
    }

    return columnData;
  };

  // If no questions set, show message
  if (totalQuestions === 0) {
    return (
      <div className="omr-container-main">
        <div className="omr-header-section">
          <button className="answers-blue-tag">Answers</button>
          <button className="back-btn" onClick={() => navigate('/')}>
            Back to Upload
          </button>
        </div>
        <div className="omr-content-card">
          <div className="no-questions-message">
            <h3>No Questions Configured</h3>
            <p>Please set the total number of questions in the Upload page first.</p>
            <button onClick={() => navigate('/')} className="nav-btn-blue" style={{ marginTop: '20px' }}>
              Go to Upload Page
            </button>
          </div>
        </div>
      </div>
    );
  }

  const columnQuestions = getQuestionsForColumns();

  return (
    <div className="omr-container-main">
      {/* HEADER SECTION */}{
        !Omrbatches && (
          <div className="omr-header-section">
            <button className="answers-blue-tag">Answers</button>
            <div className="page-info">
              <span className="questions-info">
                (Questions {startQuestion} - {endQuestion})
              </span>
              <button
                className="nav-btn-gray"
                onClick={handleClearAll}
                style={{ padding: '8px 16px', fontSize: '13px' }}
              >
                Clear All
              </button>

              {isChanged ? (
                <button className="nav-btn-blue" onClick={handleSave}>
                  <Save size={16} style={{ marginRight: '6px' }} />
                  Save Answers
                </button>
              ) : (
                !isChanged && (
                  <button
                    className="nav-btn-blue"
                    onClick={() => navigate('/', { state: { activeTab: 'questions' } })}
                  >
                    Back to Upload
                  </button>
                )
              )}
            </div>
          </div>
        )
      }
      {Omrbatches && (
        <div className="omr-header-section">
          <span
            onClick={() => navigate("/batches")}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
              padding: "6px 12px",
              background: "#f3f4f6",
              borderRadius: "6px",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: "500",
              border: "1px solid #e5e7eb"
            }}
          >
            <IoArrowBack style={{ fontSize: "16px" }} />
            Back
          </span>
        </div>
      )}

      {/* OMR SHEET CONTENT - 4 COLUMNS */}
      <div className="omr-content-card">
        <div className="omr-grid-four-col"> {/* Changed to four-col */}
          {columnQuestions.map((columnQs, colIndex) => (
            <div key={colIndex} className="omr-column-stack">
              {renderColumn(columnQs)}
            </div>
          ))}
        </div>
        {
          totalQuestions > 40 && (
            <>
              <div className="page-indicator">
                <div className="page-numbers">
                  {Array.from({ length: totalPages }).map((_, index) => (
                    <button
                      key={index + 1}
                      className={`page-number ${currentPage === index + 1 ? 'active' : ''}`}
                      onClick={() => setCurrentPage(index + 1)}
                    >
                      {index + 1}
                    </button>
                  ))}
                </div>
              </div>
              <div className="omr-footer-nav">
                <button
                  className={`nav-btn-gray ${currentPage === 1 ? 'disabled' : ''}`}
                  onClick={goToPrevPage}
                  disabled={currentPage === 1}
                >
                  <ChevronLeft size={18} /> Previous
                </button>

                <div className="pagination-controls">
                  <button
                    className="page-nav-btn"
                    onClick={() => setCurrentPage(1)}
                    disabled={currentPage === 1}
                  >
                    First
                  </button>

                  <div className="current-page-display">
                    Page {currentPage} / {totalPages}
                  </div>

                  <button
                    className="page-nav-btn"
                    onClick={() => setCurrentPage(totalPages)}
                    disabled={currentPage === totalPages}
                  >
                    Last
                  </button>
                </div>

                <button
                  className={`nav-btn-blue ${currentPage === totalPages ? 'disabled' : ''}`}
                  onClick={goToNextPage}
                  disabled={currentPage === totalPages}
                >
                  Next <ChevronRight size={18} />
                </button>
              </div>
            </>
          )
        }
      </div>
    </div>
  );
};

export default OMRPage;